<template>
    <button
        type="button"
        class="btn btn-pdv btn-pdv-orange mr-1"
        href="javascript: void(0);"
        @click="$emit('onClick')"
    >
        <i class="fe-upload mr-1"></i>
        {{ getI18n('COMMON', 'import') }}
    </button>
</template>

<script>
export default {}
</script>
